import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import PropTypes from 'prop-types';
import useLink from 'Hooks/useLink';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import {
  TaxStrategyDetailsLayout,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTaxStrategyStepTemplate/Content/TaxStrategyDetailsLayout';
import TaxStrategyDetailsMetaOverride
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTaxStrategyStepTemplate/Content/TaxStrategyDetailsMetaOverride';
import {
  TaxStrategyDetailsSkeleton,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTaxStrategyStepTemplate/Content/TaxStrategyDetailsSkeleton';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('TaxStrategyDetailsContainer', () => ({
  root: {
    width: '100%',
  },
}));

export const TaxStrategyDetailsContainer = ({ relationship, fixedWidth }) => {
  const {
    collection, loadingError, isInitializing,
  } = useLink(relationship.link('related'));

  const classes = useStyles();
  return (
    <DataContainer
      className={classes.root}
      component={MetaResourceRenderer}
      componentProps={{
        metaOverrideSet: TaxStrategyDetailsMetaOverride,
        layout: TaxStrategyDetailsLayout,
        resource: collection?.resources()?.head(),
        LayoutProps: { fixedWidth },
      }}
      loading={isInitializing}
      loadingError={loadingError}
      skeleton={TaxStrategyDetailsSkeleton}
    />
  );
};

TaxStrategyDetailsContainer.propTypes = {
  relationship: PropTypes.object.isRequired,
};
